import { useFormikContext, FormikContextType } from "formik";

export function useSafeFormikContext<Values = any>() {
	try {
		return useFormikContext<Values>();
	} catch {
		return undefined as unknown as FormikContextType<Values> | undefined;
	}
}
